import React from "react";
import clsx from "clsx";
import styles from "./style.module.css";
import { WidgetItem, WidgetStyle } from "../../interfaces/TournamentsConfig";
import Skeleton from "../Skeleton";
import { useTranslation } from "react-i18next";

interface TournamentHeaderProps {
  loading?: boolean;
  wrapperStyle?: any;
  items?: WidgetItem[];
}

function TournamentHeader(props: TournamentHeaderProps) {
  const { loading, wrapperStyle, items=[] } = props;
  const headerText = items[0]?.header;
  const { t } = useTranslation();
  return (
    <>
      <h2
        className={clsx(
          styles.tournamentHeading,
          "fontColorBlack fontWeightBold fontSizeSm20"
        )}
      >
        {loading ? <Skeleton variant="text" /> : headerText}
      </h2>
    </>
  );
}

export default TournamentHeader;
